document.addEventListener("DOMContentLoaded", function () {
  var sort = document.querySelector("[data-swd-sort]");
  if (sort)
    sort.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sort.value);
      window.location.href = url.toString();
    });
  var filters = document.querySelector("[data-swd-filters]");
  var open = document.querySelector("[data-swd-filter-open]");
  var close = document.querySelector("[data-swd-filter-close]");
  if (filters && open)
    open.addEventListener("click", function () {
      filters.classList.add("is-open");
    });
  if (filters && close)
    close.addEventListener("click", function () {
      filters.classList.remove("is-open");
    });
  var product = document.querySelector("[data-swd-product]");
  if (!product) return;
  var mainImage = product.querySelector("[data-swd-main-media] img");
  product.querySelectorAll("[data-swd-thumb]").forEach(function (button) {
    button.addEventListener("click", function () {
      if (mainImage) {
        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.src = button.dataset.image;
        if (button.dataset.alt) mainImage.alt = button.dataset.alt;
      }
    });
  });
  var quantity = product.querySelector('input[name="quantity"]');
  var minus = product.querySelector("[data-swd-qty-minus]");
  var plus = product.querySelector("[data-swd-qty-plus]");
  if (minus)
    minus.addEventListener("click", function () {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
  if (plus)
    plus.addEventListener("click", function () {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });
  var variant = product.querySelector("[data-swd-variant]");
  if (variant)
    variant.addEventListener("change", function () {
      var option = variant.options[variant.selectedIndex];
      var price = product.querySelector("[data-swd-price]");
      var compare = product.querySelector("[data-swd-compare]");
      var add = product.querySelector("[data-swd-add]");
      price.textContent = option.dataset.price;
      compare.textContent = option.dataset.compare;
      compare.hidden =
        !option.dataset.compare ||
        option.dataset.compare === option.dataset.price;
      var available = option.dataset.available === "true";
      add.disabled = !available;
      add.textContent = available ? "Add to cart" : "Sold out";
      history.replaceState(
        {},
        "",
        window.location.pathname + "?variant=" + option.value,
      );
    });
});

document.addEventListener("DOMContentLoaded", function () {
  var filters = Array.from(
    document.querySelectorAll("[data-swd-catalog-filter]"),
  );
  if (!filters.length) return;
  var cards = Array.from(
    document.querySelectorAll("[data-swd-product-groups]"),
  );
  var empty = document.querySelector("[data-swd-catalog-empty]");
  var count = document.querySelector("[data-swd-catalog-count]");
  function applyFilter(key, updateUrl) {
    var visible = 0;
    cards.forEach(function (card) {
      var groups = (card.dataset.swdProductGroups || "").split(/\s+/);
      var show = key === "all" || groups.indexOf(key) > -1;
      card.hidden = !show;
      if (show) visible += 1;
    });
    filters.forEach(function (button) {
      var active = button.dataset.swdCatalogFilter === key;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
    if (empty) empty.hidden = visible > 0;
    if (count) {
      count.querySelector("b").textContent = visible;
      count.querySelector("span").textContent = visible === 1 ? "product" : "products";
    }
    if (updateUrl) {
      var url = new URL(window.location.href);
      if (key === "all") url.searchParams.delete("type");
      else url.searchParams.set("type", key);
      history.replaceState({}, "", url.toString());
    }
  }
  filters.forEach(function (button) {
    button.addEventListener("click", function () {
      applyFilter(button.dataset.swdCatalogFilter, true);
      document
        .querySelector(".swd-catalog__bar")
        .scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });
  var initial = new URL(window.location.href).searchParams.get("type") || "all";
  if (
    !filters.some(function (button) {
      return button.dataset.swdCatalogFilter === initial;
    })
  )
    initial = "all";
  applyFilter(initial, false);
});

document.addEventListener("DOMContentLoaded", function () {
  var product = document.querySelector("[data-swd-product]");
  if (!product) return;
  var variantInput = product.querySelector("input[data-swd-variant]");
  var optionSelects = Array.from(product.querySelectorAll("[data-swd-option]"));
  var variantsNode = document.querySelector("[data-swd-product-json]");
  var variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
      style: "currency",
      currency:
        window.Shopify && Shopify.currency ? Shopify.currency.active : "USD",
    }).format(cents / 100);
  }
  function resolveVariant() {
    var chosen = optionSelects.map(function (select) {
      return select.value;
    });
    var selected = variants.find(function (item) {
      return chosen.every(function (value, index) {
        return item.options[index] === value;
      });
    });
    if (!selected || !variantInput) return;
    variantInput.value = selected.id;
    var price = product.querySelector("[data-swd-price]");
    var compare = product.querySelector("[data-swd-compare]");
    var add = product.querySelector("[data-swd-add]");
    price.textContent = money(selected.price);
    compare.textContent = selected.compare_at_price
      ? money(selected.compare_at_price)
      : "";
    compare.hidden =
      !selected.compare_at_price || selected.compare_at_price <= selected.price;
    add.disabled = !selected.available;
    add.textContent = selected.available ? "Add to cart" : "Sold out";
    history.replaceState(
      {},
      "",
      window.location.pathname + "?variant=" + selected.id,
    );
  }
  optionSelects.forEach(function (select) {
    select.addEventListener("change", resolveVariant);
  });
  if (optionSelects.length) resolveVariant();
  product
    .querySelectorAll('.swd-nfc-file input[type="file"]')
    .forEach(function (input) {
      input.addEventListener("change", function () {
        var output = input.parentElement.querySelector("[data-swd-file-name]");
        output.textContent =
          input.files && input.files[0]
            ? input.files[0].name
            : "Choose your logo file";
      });
    });
});
